import { render, staticRenderFns } from "./AamsUnitRegInfoContactDetail.vue?vue&type=template&id=5802a666&scoped=true&"
import script from "./AamsUnitRegInfoContactDetail.vue?vue&type=script&lang=js&"
export * from "./AamsUnitRegInfoContactDetail.vue?vue&type=script&lang=js&"
import style0 from "./AamsUnitRegInfoContactDetail.vue?vue&type=style&index=0&id=5802a666&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5802a666",
  null
  
)

export default component.exports